module.exports = __webpack_public_path__ + "img/达美整形.7fd65ff.png";